define(['common/parameterApplications'], function(parameterApplications) {
    var fieldName = 'contentType';

    return {
        setField: function(fields) {
            fields[fieldName] = {
                application: parameterApplications.PATH
            };
            return fields;
        },

        setValue: function(requestOptions) {
            requestOptions[fieldName] = 'json';
            return requestOptions;
        }
    };
});



// WEBPACK FOOTER //
// ./rest/routing/request/contentTypeConfigurer.js